<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>预算项目</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="code" placeholder="请输入代码" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="name" placeholder="请输入名称" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.timeliness">
                <el-select style="width: 100%" v-model="timeliness" placeholder="请选择时效性" size="mini" clearable>
                    <el-option v-for="item in timeLinessOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.status">
                <el-select style="width: 100%" v-model="status" placeholder="请选择状态" size="mini" clearable>
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.control">
                <el-select style="width: 100%" v-model="control" placeholder="请选择是否控制预算" size="mini" clearable>
                    <el-option v-for="item in controlOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.beneficiary_rid">
                <el-select style="width: 100%" v-model="beneficiary_rid" placeholder="请选择受益人" size="mini" clearable filterable>
                    <el-option v-for="item in beneficiaryOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.principal_rid">
                <el-select style="width: 100%" v-model="principal_rid" placeholder="请选择负责人" size="mini" clearable filterable>
                    <el-option v-for="item in principalOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.project_rid">
                <el-select style="width: 100%" v-model="project_rid" placeholder="请选择项目" size="mini" clearable filterable>
                    <el-option v-for="item in projectOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.department_rid">
                <el-select style="width: 100%" v-model="department_rid" placeholder="请选择部门" size="mini" clearable filterable>
                    <el-option v-for="item in departmentOptions" :key="item.rid" :label="item.name + '-' + item.code" :value="item.rid">
                    </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.budget_subject_rid">
                <el-select style="width: 100%" v-model="budget_subject_rid" placeholder="请选择预算科目" size="mini" clearable filterable>
                    <el-option v-for="item in budgetOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.control_scope">
                <el-select style="width: 100%" v-model="control_scope" placeholder="请选择控制范围" size="mini" clearable>
                    <el-option v-for="item in controlScopeOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_items" v-if="postList.period">
                <el-date-picker v-model="period" type="year" placeholder="请选择年" format="yyyy年" value-format="yyyy" clearable>
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增预算项目</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="budget_item"></crm-upload>
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                v-loading="loading"
                class="budget_item"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="item.prop == 'status'">
                                <span v-if="scope.row.status == 1" class="status_1">{{ scope.row.status_label }}</span>
                                <span v-else class="status_2">{{ scope.row.status_label }} </span>
                            </div>
                            <div
                                v-if="
                                    item.prop == 'code' ||
                                    item.prop == 'name' ||
                                    item.prop == 'beneficiary_name' ||
                                    item.prop == 'principal_name' ||
                                    item.prop == 'department_name'
                                "
                            >
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-if="item.prop == 'budget_subject_name'">
                                <el-link v-if="showType" type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                                <span v-else>{{ scope.row[item.prop] }}</span>
                            </div>
                            <div v-else>
                                <span v-if="item.prop == 'timeliness'">{{ scope.row.timeliness_label }}</span>
                                <span v-else-if="item.prop == 'control_scope'">{{ scope.row.control_scope_label }}</span>
                                <span v-else> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                        <el-tooltip v-if="scope.row.status == 1" class="item" effect="dark" content="关闭预算" placement="top-start">
                            <i class="el-icon-s-help" @click="colseCilck(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip v-else class="item" effect="dark" content="打开预算" placement="top-start">
                            <i class="el-icon-success" @click="openCilck(scope.row.rid)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'budgetItemListComponent',
    data() {
        return {
            draggable: {
                data_name: 'budget_item'
            },
            dialogVisible: false,
            budgetOptions: [],
            down_loading: false,
            tableData: [],
            timeliness: '',
            status: '',
            control: '',
            beneficiary_rid: '',
            principal_rid: '',
            beneficiaryOptions: [],
            principalOptions: [],
            project_rid: '',
            projectOptions: [],
            department_rid: '',
            budget_subject_rid: '',
            showType: true,
            control_scope: '',
            departmentOptions: [],
            controlScopeOptions: [],
            controlOptions: [
                {
                    value: 1,
                    name: '是'
                },
                {
                    value: 2,
                    name: '否'
                }
            ],
            timeLinessOptions: [
                {
                    value: 1,
                    name: '效期前'
                },
                {
                    value: 2,
                    name: '效期中'
                },
                {
                    value: 3,
                    name: '效期后'
                }
            ],
            statusOptions: [
                {
                    value: 1,
                    name: '开放'
                },
                {
                    value: 2,
                    name: '关闭'
                }
            ],
            checkAll: true,
            name: '',
            period: '',
            //控制列
            colData: [],
            //控制列
            code: '', //code
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['budgetItem_params']) {
                this.page = paramsList['budgetItem_params'].page;
                this.row = paramsList['budgetItem_params'].row;
                // this.data_name = paramsList['budgetItem_params'].data_name;
                // this.sort = paramsList['budgetItem_params'].sort;
                this.name = paramsList['budgetItem_params'].name;
                this.code = paramsList['budgetItem_params'].code;
                this.period = paramsList['budgetItem_params'].period;
                this.timeliness = paramsList['budgetItem_params'].timeliness;
                this.status = paramsList['budgetItem_params'].status;
                this.beneficiary_rid = paramsList['budgetItem_params'].beneficiary_rid;
                this.project_rid = paramsList['budgetItem_params'].project_rid;
                this.principal_rid = paramsList['budgetItem_params'].principal_rid;
                this.department_rid = paramsList['budgetItem_params'].department_rid;
                this.budget_subject_rid = paramsList['budgetItem_params'].budget_subject_rid;
                this.control_scope = paramsList['budgetItem_params'].control_scope;
                this.control = paramsList['budgetItem_params'].control;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
                if (this.postList.params.beneficiary_rid) {
                    this.principal_rid = '';
                    this.beneficiary_rid = this.postList.params.beneficiary_rid;
                    this.getList(0); //获取列表
                }
                if (this.postList.params.principal_rid) {
                    this.beneficiary_rid = '';
                    this.principal_rid = this.postList.params.principal_rid;
                    this.getList(0); //获取列表
                }
                if (this.postList.params.budget_subject_rid) {
                    this.budget_subject_rid = this.postList.params.budget_subject_rid;
                    this.getList(0); //获取列表
                }
                if (this.postList.params.budget_subject_rid_show) {
                    this.showType = true;
                }
                if (this.postList.params.department_rid) {
                    this.department_rid = this.postList.params.department_rid;
                    this.getList(0); //获取列表
                }
            } else {
                this.getList(0); //获取列表
                this.getPrincipal(); //获取受益人  负责人下拉
                this.getProject(); //项目下拉
                this.getBudgetSubjects(); //预算科目下拉
                this.remoteDepartment(); //部门下拉
                this.getControl(); //控制范围下拉
            }
        });
    },
    methods: {
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('budget_item', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).budget_item;
        },
        //前往编辑页面
        editDetails(id) {
            this.$router.push({
                path: 'budgetItemEdit',
                query: {
                    type: 1,
                    id: id
                }
            });
        },
        //复制页面
        copy(id) {
            this.$router.push({
                path: 'budgetItemEdit',
                query: {
                    type: 5,
                    id: id
                }
            });
        },
        //重新打开预算
        openCilck(rid) {
            var params = {
                rid: rid
            };
            let messages = '此操作将重新打开此条数据的预算，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '打开...';
                        this.$api
                            .budgetItemReOpen(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '打开成功',
                                        type: 'success'
                                    });
                                    this.getList(0);
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //关闭预算
        colseCilck(rid) {
            var params = {
                rid: rid
            };
            let messages = '此操作将关闭此条数据的预算，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '关闭...';
                        this.$api
                            .budgetItemClose(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '关闭成功',
                                        type: 'success'
                                    });
                                    this.getList(0);
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //控制范围下拉
        getControl() {
            let params = {};
            this.$api
                .dropdownControlScope(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.controlScopeOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //部门下拉
        remoteDepartment() {
            let params = {
                all_status: 1
            };
            this.$api
                .budgetDepartment(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.departmentOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //预算科目下拉
        getBudgetSubjects() {
            let params = {};
            this.$api
                .dropdownBudgetSubjects(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.budgetOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //项目下拉
        getProject() {
            let params = {};
            this.$api
                .dropdownProjects(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.projectOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取受益人  负责人下拉
        getPrincipal() {
            let params = {};
            this.$api
                .dropdownPerson(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.beneficiaryOptions = res.data;
                        this.principalOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$api
                        .budgetItemDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetItem_params']) {
                    newParamsList['budgetItem_params'].data_name = val.prop;
                    newParamsList['budgetItem_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //新增
        addAcount() {
            this.$router.push({
                path: 'BudgetItemEdit',
                query: {
                    type: 3
                }
            });
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'code' || prop == 'name') {
                this.$router.push({
                    path: '/budgetItemDetails',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'budget_subject_name') {
                this.$router.push({
                    path: '/budgetAccountDetails',
                    query: {
                        id: row.budget_subject_rid
                    }
                });
            } else if (prop == 'beneficiary_name') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.beneficiary_rid
                    }
                });
            } else if (prop == 'principal_name') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.principal_rid
                    }
                });
            } else if (prop == 'department_name') {
                this.$router.push({
                    path: '/departmentDetails',
                    query: {
                        id: row.department_rid
                    }
                });
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                sort: [this.data_name, this.sort],
                is_export: type_data,
                name: this.name,
                code: this.code,
                period: this.period,
                timeliness: this.timeliness,
                status: this.status,
                beneficiary_rid: this.beneficiary_rid,
                project_rid: this.project_rid,
                principal_rid: this.principal_rid,
                department_rid: this.department_rid,
                budget_subject_rid: this.budget_subject_rid,
                control_scope: this.control_scope,
                control: this.control
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['budgetItem_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.$api
                    .budgetItemLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['budgetItem_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .budgetItemListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetItem_params']) {
                    newParamsList['budgetItem_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        sort: [this.data_name, this.sort],
                        name: this.name,
                        code: this.code,
                        period: this.period,
                        timeliness: this.timeliness,
                        status: this.status,
                        beneficiary_rid: this.beneficiary_rid,
                        project_rid: this.project_rid,
                        principal_rid: this.principal_rid,
                        department_rid: this.department_rid,
                        budget_subject_rid: this.budget_subject_rid,
                        control_scope: this.control_scope,
                        control: this.control
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetItem_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetItem_params']) {
                    newParamsList['budgetItem_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        sort: [this.data_name, this.sort],
                        name: this.name,
                        code: this.code,
                        period: this.period,
                        timeliness: this.timeliness,
                        status: this.status,
                        beneficiary_rid: this.beneficiary_rid,
                        project_rid: this.project_rid,
                        principal_rid: this.principal_rid,
                        department_rid: this.department_rid,
                        budget_subject_rid: this.budget_subject_rid,
                        control_scope: this.control_scope,
                        control: this.control
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetItem_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.code = '';
            this.name = '';
            this.period = '';
            this.timeliness = '';
            this.status = '';
            this.beneficiary_rid = '';
            this.project_rid = '';
            this.principal_rid = '';
            this.department_rid = '';
            this.budget_subject_rid = '';
            this.control_scope = '';
            this.control = '';
            this.page = 1;
            this.row = 25;
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                name: '',
                code: '',
                period: '',
                timeliness: '',
                status: '',
                beneficiary_rid: '',
                project_rid: '',
                principal_rid: '',
                department_rid: '',
                budget_subject_rid: '',
                control_scope: '',
                control: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['budgetItem_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
.status_1 {
    color: green;
}
.status_2 {
    color: red;
}
</style>